<mat-card class="pattern-analysis-card">
  <div
    class="pattern-header"
    role="button"
    tabindex="0"
    (click)="toggleCollapsed()"
    (keydown.enter)="toggleCollapsed()"
    (keydown.space)="toggleCollapsed(); $event.preventDefault()"
    [attr.aria-expanded]="!collapsed()"
  >
    <div class="pattern-header-left">
      <mat-icon class="pattern-icon">insights</mat-icon>
      <span class="pattern-title">Pattern Detection</span>
    </div>
    <div class="pattern-header-right">
      @if (model()) {
        <span class="pattern-model">{{ model() }}</span>
      }
      @if (hasAnalysis) {
        <button
          mat-icon-button
          class="copy-btn"
          (click)="$event.stopPropagation(); copyAnalysis()"
          [matTooltip]="copied() ? 'Copied!' : 'Copy'"
        >
          <mat-icon>{{ copied() ? "check" : "content_copy" }}</mat-icon>
        </button>
      }
      @if (hasAnalysis) {
        <button
          mat-icon-button
          class="collapse-btn"
          (click)="$event.stopPropagation(); toggleCollapsed()"
        >
          <mat-icon>{{ collapsed() ? "expand_more" : "expand_less" }}</mat-icon>
        </button>
      }
    </div>
  </div>

  <!-- Loading jobs -->
  @if (loadingJobs()) {
    <div class="pattern-loading">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Loading job history&hellip;</span>
    </div>
  }

  <!-- Streaming -->
  @if (streaming() && !loadingJobs()) {
    <div class="pattern-loading">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Analyzing patterns&hellip;</span>
      <button
        mat-icon-button
        class="stop-btn"
        (click)="stopStreaming()"
        matTooltip="Stop"
      >
        <mat-icon>stop</mat-icon>
      </button>
    </div>
  }

  <!-- Error -->
  @if (error() && !loading) {
    <div class="pattern-error">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ error() }}</span>
      <button mat-stroked-button class="retry-btn" (click)="analyze()">
        Retry
      </button>
    </div>
  }

  <!-- Streaming / complete content -->
  @if (hasAnalysis && !collapsed()) {
    <div class="pattern-content">
      <div class="pattern-markdown" [innerHTML]="renderedAnalysisHtml()"></div>
      @if (usage()) {
        <div class="pattern-usage">
          <span>{{ usage()!.inputTokens + usage()!.outputTokens }} tokens used</span>
        </div>
      }
    </div>
  }

  <!-- Not analyzed yet -->
  @if (!hasAnalysis && !loading && !error()) {
    <div class="pattern-prompt">
      <button mat-stroked-button (click)="analyze()">
        <mat-icon>auto_awesome</mat-icon>
        Analyze patterns
      </button>
    </div>
  }
</mat-card>
